<template>
  <Head title="Results - Projections vs. Actuals" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <proj-vs-actuals 
            :plan="plan" 
            :client="client" 
            :customizations="customizations"
            :projections="projections" 
            :actuals="actuals" 
            :notifications="notifications"
          ></proj-vs-actuals>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  plan: Object,
  client: Object,
  projections: Array,
  actuals: Array,
  customizations: Array,
  notifications: Array
});
</script>

